const About = {
    sub: "About Us",
    heading: "Your Trusted Source for Quality Gardening and Landscaping",
    description: "Welcome to Botanica, your premier destination for top-quality gardening and landscaping solutions. We are committed to delivering exceptional craftsmanship and services to transform your outdoor spaces into stunning landscapes.",
    experience: {
        years: 35,
        text: "years of experience"
    },
    points: [
        'Custom Garden Designs',
        'Expert Landscaping Services',
        'High-Quality Planting Options',
        'Precision Craftsmanship'
    ],
    button: {
        text: "Contact Us",
        link: 'contact-us'
    }
}

export default About;